import { register } from "async-ops";
import { callMvcApi } from "../../../../call-web-api";
export const GET_AUDIT_PROCESS_TEMPLATE_GROUP_LIST =
  "GET_AUDIT_PROCESS_TEMPLATE_GROUP_LIST";

export const service = async (data) => {
  const options: object = {
    url: `/Api/Admin/GetAuditGroupList/true/Process Templates/false`,
    method: "GET",
  };
  const response = callMvcApi(options);
  return response;
};

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(GET_AUDIT_PROCESS_TEMPLATE_GROUP_LIST, service, mock);
